import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';

import { IAppState } from '../../../../state/reducers';
import { Product } from '../../../../state/product';
import { Container, NavOptionContainer } from './styles';
import { Routes } from '../../../../constants';
import { UiSection } from '../../../../enums';
import { VaultButton } from '../../../Shared';
import { IProps, IStateProps } from './interfaces';
import {
  selectIsUserVaultSuperAdmin,
  selectIsUserExchangeAdmin,
  selectIsUserExchangeVendor,
} from '../../../../state/user/userOrgRole';

class MainNav extends PureComponent<IProps, any> {
  private static readonly homeID = `${UiSection.Header}.home`;
  private static readonly exchangeID = `${UiSection.Header}.exchange`;

  isNavOptionActive(segment: string) {
    const { location } = this.props;

    return location.pathname.startsWith(segment);
  }

  render() {
    const {
      isVaultSuperAdmin,
      isExchangeAdmin,
      isExchangeVendor,
      isExchange,
      isMyVault,
    } = this.props;
    const activeLinkStyle = ({ isActive }: { isActive: boolean }) => (isActive ? { color: 'red' } : undefined);

    return (
      <Container id="mainNavContainer">
        <NavOptionContainer $isActive={this.isNavOptionActive(Routes.HOME)}>
          <NavLink to={Routes.HOME} style={activeLinkStyle}>
            <VaultButton id={MainNav.homeID} variant="transparentOnBlack">
              Home
            </VaultButton>
          </NavLink>
          {
              (isVaultSuperAdmin || isExchangeAdmin || isExchangeVendor) && isExchange && (
                <NavLink to={Routes.EXCHANGE} style={activeLinkStyle}>
                  <VaultButton id={MainNav.exchangeID} variant="transparentOnBlack">
                    Search
                  </VaultButton>
                </NavLink>
              )
            }
        </NavOptionContainer>
      </Container>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isVaultSuperAdmin: selectIsUserVaultSuperAdmin(state),
  isExchangeAdmin: selectIsUserExchangeAdmin(state),
  isExchangeVendor: selectIsUserExchangeVendor(state),
  isExchange: state.product.target === Product.Exchange,
  isMyVault: state.product.target === Product.MyVault,
});

const ConnectedMainNav = connect(
  mapStateToProps,
)(MainNav);

// Wrapper component to provide location via hook
const MainNavWithRouter: React.FC = () => {
  const location = useLocation();
  return <ConnectedMainNav location={location} />;
};

export default MainNavWithRouter;
